import { SocialCounts } from '../../domain/models';
import { SocialRepository } from '../../domain/repositories';
import { SocialDataSource } from '../datasources/SocialDataSource';

export class SocialRepositoryImpl implements SocialRepository {
  constructor(private dataSource: SocialDataSource) {}

  async getCounts(userId: string): Promise<SocialCounts> {
    return await this.dataSource.getCounts(userId);
  }
}
